export default function Hero() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20abstract%20composition%20featuring%20flowing%20organic%20shapes%20in%20rich%20earthy%20terracotta%20warm%20ochre%20and%20deep%20forest%20green%20tones%2C%20layered%20translucent%20curves%20creating%20depth%20and%20movement%2C%20sophisticated%20modern%20art%20gallery%20aesthetic%2C%20soft%20diffused%20lighting%20with%20subtle%20gradient%20transitions%2C%20luxurious%20contemporary%20design%20background%2C%20artistic%20editorial%20style%20with%20refined%20texture%20details&width=1920&height=1080&seq=hero-bg-v2&orientation=landscape"
          alt="CSSBuy Spreadsheet resource hub background"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 lg:px-20">
        <div className="max-w-4xl">
          <p className="text-white/70 text-sm md:text-base font-label tracking-widest uppercase mb-4">
            The Ultimate Shopping Spreadsheet Resource
          </p>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight mb-6">
            CSSBuy<br />
            Spreadsheet<br />
            <span className="text-white/80">Resource Hub</span>
          </h1>
          <p className="text-white/70 text-base md:text-lg max-w-xl mb-8 leading-relaxed">
            Manage, organize and compare your CSSBuy products with powerful spreadsheet templates,
            guides and tools designed for smarter online shopping.
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-200"
            >
              CSSBuy Sheet
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-6 py-3 rounded-full border border-white/30 text-white font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-white/10 transition-all duration-200"
            >
              Buy It Now
              <i className="ri-shopping-cart-line ml-2"></i>
            </a>
          </div>
          <div className="flex flex-wrap items-center gap-6 mt-8">
            <span className="flex items-center gap-2 text-white/60 text-xs">
              <i className="ri-check-line text-primary-400"></i>
              Free Spreadsheet Resources
            </span>
            <span className="flex items-center gap-2 text-white/60 text-xs">
              <i className="ri-check-line text-primary-400"></i>
              Updated Shopping Guides
            </span>
            <span className="flex items-center gap-2 text-white/60 text-xs">
              <i className="ri-check-line text-primary-400"></i>
              Comparison Tools
            </span>
            <span className="flex items-center gap-2 text-white/60 text-xs">
              <i className="ri-check-line text-primary-400"></i>
              Secure Information
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}